class ClickCollectState  {
    constructor() {
        this._state = {};

        this._doRender = this._doRender.bind(this);

        this.statePath =  {
            store: 'store',
        }

        this.cookieName = 'clickCollectStore';
    }

    getState(path) {
        return this._state[path];
    }


    setState(path, value) {
        if (this._state[path] !== value) {
            this._state[path] = value;
            this._doRender();
        }
    }

    _doRender() {
         return null;
    }
}

const clickCollectStateManager = new ClickCollectState();

class middleWareClickCollect extends HTMLElement {
    constructor() {
        super();
        this.stateManager = clickCollectStateManager;
        this.statePath = this.stateManager.statePath;
        this.cookieName = this.stateManager.cookieName;
        this.template = document.getElementById("template-click-collect").content;
        this.stateManager._doRender = this._doRender;
        this.storefrontAPIKey = '97e25c416416a9def3556cb097f6d4cd';
        this._isOpened = false;

    }

    getState(path) {
        return this.stateManager.getState(path);
    }

    setState(path, value) {
        return this.stateManager.setState(path, value);
    }

    onChangeStore(e, target) {
        const id = target.dataset.value;
        this.setState(this.statePath.store, id);
        this.setCookie(this.cookieName, id);
    }

    async getStores() {
        const response = await fetch(`/api/2023-10/graphql.json`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": this.storefrontAPIKey
            },
            body: JSON.stringify({
                query: `
				   query LocationsByDistance {
					  locations(first: 100) {
						edges {
						  node {
							name
							id
						  }
						}
					  }
					}
				  `,
            })
        });

        return await response.json();
    }

    async defineStores() {
        const graphStores = await this.getStores();
        const edgesStores = graphStores?.data?.locations?.edges;

        return edgesStores.length ? edgesStores.map( store => {
            return {
                id: store.node.id,
                name: store.node.name
            }
        }) : [];
    }

    getStore() {
        return this.getState(this.statePath.store) || this.getCookie(this.cookieName) || null;
    }

    initCookieLogic() {
        const store = this.getStore();
        if (store) {
            this.setState(this.statePath.store, store)
        } else {
            this.setState(this.statePath.store, null);
        }
    }


    getCookie(name) {
        const matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ))
        return matches ? decodeURIComponent(matches[1]) : undefined
    }

    setCookie(name, value, options = {}) {

        options = {
            path: '/',
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    customDelegate(eventName, elementSelector, handler) {
        this.addEventListener(eventName, (e) => {
            const element = e.target.closest(elementSelector);

            if (element) {
                handler.call(element, e, element);
            }
        }, false);
    };

    toggleDropdown(show) {
        show = (show !== undefined) ? show : !this._isOpened;
        this._isOpened = show;
        this._isOpened ? this.componentList.setAttribute('open','') : this.componentList.removeAttribute('open');
    };

    fieldClickHandler() {
        this._isOpened ? this.close() : this.open();
    };

    close() {
        this.toggleDropdown(false);
    };

    open() {
        this.toggleDropdown(true);
    }


    _doRender() {
        document.dispatchEvent(new CustomEvent('collect:updateState'));
    }
}

class ComponentClickCollectHeader extends middleWareClickCollect {
    constructor() {
        super();

    }

    connectedCallback() {
        this.defineStores().then(stores => {
            this.stores = stores;
            if (!stores.length) {
                return null;
            }
            this.defineElements();
            this.renderStoreList(stores);
            this.initCookieLogic();
            this.addListeners();
            this.render();
        });


    }

    defineElements() {
        this.$headerPlaceholder = this.template.getElementById('placeholder-status-header');
        this.$selectedStatus = this.template.getElementById('selected-status');
        this.$storeList = this.template.getElementById('store-list');
        this.componentHeader = this.querySelector('component-click-collect-header');
        this.componentList = this.querySelector('component-click-collect-list');
    }

    addListeners() {
        this.customDelegate(
            "click",
            '.click-collect__store-item',
            this.onChangeStore.bind(this)
        )

        document.addEventListener('collect:updateState',() => {
            this.render();
        })
    }

    renderStoreList(stores) {

        if (!stores.length || !this.componentList) {
            return null;
        }

        const html =  this.$storeList.cloneNode(true);

        stores.forEach(store => {
            html.insertAdjacentHTML( 'beforeend',
                `<li class="click-collect__store-item" data-value="${store.id}">${store.name}</li>`
            )
        })

        this.componentList.innerHTML = html.innerHTML;
    }

    renderPlaceholder() {
        this.componentHeader.innerHTML = this.$headerPlaceholder.innerHTML;
    }

    renderSelected() {
        const id = this.getState(this.statePath.store)

        const selectedStore = this.stores.find(el => el.id === id)
        this.componentHeader.innerHTML = this.$selectedStatus.innerHTML.replace('{store}', selectedStore.name);
    }

    render() {
        const store = this.getState(this.statePath.store);
        if (store) {
            this.renderSelected()
        } else {
            this.renderPlaceholder()
        }
    }
}


class ComponentClickCollectHeaderMobile extends ComponentClickCollectHeader {
    constructor() {
        super();
    }

    connectedCallback() {
         super.connectedCallback();

    }

    defineElements() {
        this.$headerPlaceholder = this.template.getElementById('placeholder-status-header');
        this.$selectedStatus = this.template.getElementById('selected-status');
        this.$storeList = this.template.getElementById('store-list');
        this.componentHeader = this.querySelector('component-click-collect-change');
        this.componentList = this.querySelector('component-click-collect-list');
    }

    addListeners() {
        super.addListeners();

        this.customDelegate(
            "click",
            'component-click-collect-change',
            this.fieldClickHandler.bind(this)
        )
    }

    onChangeStore(e, target) {
        super.onChangeStore(e, target);
        this.close();
    }

}

class ComponentClickCollectProduct extends middleWareClickCollect  {
    constructor() {
        super();
        this._isOpened = false;
        this.variantId = this.dataset.variantId;
        this.dataJetTask = "/apps/datajet/task/6578340564290cc481733570";
        this.dataJetToken = "ul46186bjjrgnsv3dhckpsnqmb0zgurp";
    }

    connectedCallback() {

        if (!this.variantId) {
            return null
        }

        this.defineStores().then(stores => {
            this.stores = stores;
            this.defineElements();
            this.renderDeliveryByAdminAPI(this.variantId);
            this.renderStoreList(stores);
            this.initCookieLogic();
            this.addListeners();
            this.initProductAvailability().then(variantList => {
                this.variantList = variantList;
                this.render();
            })
        });
    }

   async renderDeliveryByAdminAPI(variantID) {
      const response = await this.getQuantity(variantID);
      if (response.result.hasOwnProperty('error')) {
          console.log(response.result.error[0]);
          return null;
      }

      this.renderDelivery(response);

    }

    async getQuantity(variantID) {
       return await fetch(this.dataJetTask, {
            method: "POST",
           headers: {
               "Content-Type": "application/json",
               "token": this.dataJetToken
           },
            body: JSON.stringify({
                variantID
            })
        }).then(response => response.json())
    }

    async initProductAvailability() {
        return await this.fetchAvailableVariant(this.variantId);
    }

    defineElements() {
        this.$storeList = this.template.getElementById('store-list');
        this.$successStatus = this.template.getElementById('success-status');
        this.$errorStatus = this.template.getElementById('error-status');
        this.$placeholder = this.template.getElementById('placeholder-status');
        this.$deliveryAvailable =  this.template.getElementById('delivery-available');
        this.$deliveryUnavailable =  this.template.getElementById('delivery-unavailable');
        this.componentList = this.querySelector('component-click-collect-list');
        this.componentPickup = this.querySelector('component-click-collect-pickup');
        this.componentDelivery = this.querySelector('component-click-collect-delivery');

    }

    onChangeStore(e, target) {
        super.onChangeStore(e, target);
        this.close();

    }


    addListeners() {

        document.addEventListener('collect:updateState',() => {
            this.render();
        })


        this.customDelegate(
            "click",
            'component-click-collect-change',
            this.fieldClickHandler.bind(this)
        )

        this.customDelegate(
            "click",
            '.click-collect__store-item',
            this.onChangeStore.bind(this)
        )
    }

    renderStoreList(stores) {

        if (!stores.length || !this.componentList) {
            return null;
        }

        const html =  this.$storeList.cloneNode(true);

        stores.forEach(store => {
            html.insertAdjacentHTML( 'beforeend',
                `<li class="click-collect__store-item" data-value="${store.id}">${store.name}</li>`
            )
        })

        this.componentList.innerHTML = html.innerHTML;
    }


    async fetchAvailableVariant(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
            rootUrl = rootUrl + '/';
        }

        try {
            const data = await (await fetch(`${rootUrl}variants/${variantId}/?section_id=api-click-collect`)).text();

            const parser = new DOMParser();
            const node = parser.parseFromString(data.toString(), 'text/html').querySelector('.shopify-section');
            if (!node) {
                console.error('No node found in', data);
                return [];
            }
            const content = (node.textContent || '').trim();

            return JSON.parse(content);
        } catch (e) {
            console.error(e);
        }

        return [];
    }

    renderDelivery(response) {
        const quantities = response?.result?.productVariant?.inventoryItem?.inventoryLevel?.quantities;

        if (!quantities) {
            this.componentDelivery.classList.add('delivery_unavailable')
            this.componentDelivery.innerHTML = this.$deliveryUnavailable.innerHTML;
        }
        const quantity = quantities.find(qty => qty.name === 'available');

        if (quantity?.quantity >= 1 ) {
            this.componentDelivery.classList.remove('delivery_unavailable')
            this.componentDelivery.innerHTML = this.$deliveryAvailable.innerHTML;
        } else {
            this.componentDelivery.classList.add('delivery_unavailable')
            this.componentDelivery.innerHTML = this.$deliveryUnavailable.innerHTML;
        }
    }


    render() {

        const selectedStore = this.getStore();
        const storeName = this.stores.find(el => el.id === selectedStore);


        if (!selectedStore) {
            this.renderPleaseChooseStore();
            return  null;
        }

        if (!this.variantList || !this.variantList.length) {
            this.renderUnavailability(storeName.name);
            return null;
        }

        const liquidID = selectedStore.replace(/[^0-9]/g, "");
        const findStore = this.variantList.find(el => el.id === liquidID);

        if (!findStore || !findStore?.available) {
            this.renderUnavailability(storeName.name);
        } else {
            this.renderAvailability(storeName.name);
        }
    }

    renderPleaseChooseStore() {
        this.componentPickup.innerHTML = this.$placeholder.innerHTML;
    }

    renderAvailability(name) {
        this.componentPickup.innerHTML = this.$successStatus.innerHTML.replace('{store}', name);
    }

    renderUnavailability(name) {
        this.componentPickup.innerHTML = this.$errorStatus.innerHTML.replace('{store}', name);
    }
}




if (!window.customElements.get("component-click-collect")) {
    customElements.define('component-click-collect', ComponentClickCollectHeader);
}

if (!window.customElements.get("component-click-collect-mobile")) {
    customElements.define('component-click-collect-mobile', ComponentClickCollectHeaderMobile);
}

if (!window.customElements.get("component-click-collect-product")) {
    customElements.define('component-click-collect-product', ComponentClickCollectProduct);

}




